module.exports={
    "Product": "HeadlightConfigurableApplication",
    "ProductVersion": "1.0.0",

    "Manifests":
    {
    }
}
